import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { ArrowRight } from "lucide-react";
import Button from "../components/Shared/Button";
import PageBanner from "../components/Shared/PageBanner";
import { ENROLMENT_TERMS } from "../constants/enrolmentTerms";

const TermsAndConditions = () => {
  return (
    <div className="pb-16">
      <Helmet>
        <link
          rel="canonical"
          href="https://www.nilewisect.com/terms-and-conditions"
        />
      </Helmet>

      <PageBanner title="Terms and Conditions" />

      <div className="container pt-10">
        <div className="border border-black/15 rounded-md w-full bg-white p-6 sm:p-8">
          <div className="space-y-5 text-textPrimary">
            {ENROLMENT_TERMS.map(({ id, title, body }) => (
              <section key={id}>
                <h2 className="text-xl font-bold mb-2">
                  {id}. {title}
                </h2>
                <p className="text-burntBlack/85">{body}</p>
              </section>
            ))}
          </div>

          <div className="flex justify-center mt-10">
            <Link to="/courses">
              <Button
                variant="primary"
                className="!h-12 px-8 !text-base rounded-[12px]"
              >
                View Courses <ArrowRight size={20} />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
